<template>

	<div id="app" :class="[$style.appBar, {'lexus':brand==brand_lexus || brand==brand_all}, {'toyota':brand==brand_toyota || brand==brand_all}]">
		<!-- <button style="z-index:1000; position:fixed; bottom: 10px; left: 10px;" @click="cycleBrand">
			<i class="fa fa-exchange-alt"/>
		</button> -->
		<div :class="$style.version">Version: {{version}}</div>
		<div id="nav" v-show="isLoggedIn">
			<div :class="$style.navmain">
				<div :class="$style.logowrapper">
					<router-link to="/" :class="$style.logo">
						<template v-if="brand==brand_toyota || brand==brand_lexus ">
							<img  v-if="brand==brand_toyota" :src="toyota" style="height:40px;" class="header_logo"/>
							<img  v-if="brand==brand_lexus && userLanguage == 'en'" :src="lexus" style="height:36px;transform:translateY(2px)" class="header_logo"/>
							<img  v-if="brand==brand_lexus && userLanguage == 'fr'" :src="lexus_fr" style="height:36px;transform:translateY(2px)" class="header_logo"/>
						</template>

						<div v-if="brand==brand_all" style="position:relative;top:10px;">
							<img  :src="toyota" style="display:block;height:35px;transform:translateX(-10px)" class="header_logo"/>
							<img v-if="userLanguage == 'en'" :src="lexus" style="display:block;height:32px;transform:translateY(2px);border-top: 1px solid lightgrey;padding-top:3px;" class="header_logo"/>
							<img v-if="userLanguage == 'fr'" :src="lexus_fr" style="display:block;height:32px;transform:translateY(2px);border-top: 1px solid lightgrey;padding-top:3px;" class="header_logo"/>
						</div>
					</router-link>

					<h1 :class="[{[$style.one_brand]:brand!=brand_all}]">{{ 'app_title' | str}} </h1>

					
					
				</div>

				<div :class="$style.userDetails">
					<template v-show="isLoggedIn">
						<div  :class="$style.username">{{fullname}}</div>
						<div :class="$style.userDetails">
							<strong>{{username}},</strong>
							{{userType}}
							<div v-if="dealerCode">
								<strong>{{'dealerCode'|str}}</strong>: {{dealerCode}}
							</div>
							<div v-if="zoneNames">
								<strong>{{'zones'|str}}</strong>: {{ zoneNames }}
							</div>
						</div>
					</template>

					<language v-on:language="language" v-bind:initial="userLanguage" style="margin: 5px 20px;"/>
				</div>
			</div> <!-- end .navmain -->


			<div :class="$style.navbar">
				<div :class="$style.navlinks">
					<router-link class="navlink" to='/'>
						<i class="fas fa-home"></i> 
						{{'home' | str}}
					</router-link>
					<router-link class="navlink" v-if="allowAdmin" to='/admin'>
						<i class="fas fa-id-badge"></i> 
						Admin
					</router-link>					
				</div>

				<div :class="$style.optionswrapper">

					<button v-show="isLoggedIn" :class="$style.logout" v-on:click="logout()">
						<i class="fas fa-sign-out-alt"></i>
						{{'logout' | str }}
					</button>
				</div>
			</div>
			
			
		</div>

		<div id="main" role="main">
			<router-view v-on:language="language"/>
		</div>

		<BusySpinner v-bind:isBusy="busyState().isBusy"/>
		<transition name='fade'>
			<div>
				<SysDialog 
					v-if="dialog.display" 
					:message="dialog.message" 
					v-on:close="close_dialog"
					/>
			</div>
		</transition>
	</div>
</template>

<script>
import SysDialog from '@/components/SysDialog/SysDialog.vue';
import toyota from '@/assets/logo_toyota.png';
import lexus from '@/assets/logo_lexus.png';
import lexus_fr from '@/assets/logo_lexus_fr.png';
import language from '@/components/Language/Language.vue'
import BusySpinner from '@/components/Busy/BusySpinner.vue'



export default {
	name: 'app',
	components: {
		BusySpinner,
		language,
		SysDialog
	},
	mounted: function() {
		var self = this;
		this.$api.setErrorCallback(this.errorHandler);

		this.$application.setSessionExpiredCallback(function() {
			self.$application.endSession();

			self.dialog.message = {
				header: self.str('session_expired'),
				body: self.str('please_log_back_in')
			};
			self.dialog.onClose = function(){
				self.close_and_recover();
			};
			self.dialog.display = true;
		});
		this.$application.initPromise.then(function(){
			self.user = self.$application.user;
		});
	},
	data: function() {
		return {
			// the user object will be set when application controller fetches it
			user: null,
			currentLang: localStorage.getItem('language') || 'en',
			brand_override: 'Toyota',
			override_index: 0,
			brand_lexus: 'Lexus',
			brand_toyota: 'Toyota',
			brand_all: 'Toyota - Lexus',
			errorMessage: null,
			dialog: {
				display: false,
				message: null,
				onClose: null
			}
		}
	},
	methods: {
		/* The error object can be one of:
			- { error: 'message', error_fr:'french message'}
			- { message: 'error message' }
			- 'A plain error string'
		*/
		errorHandler: function(error) {
			console.log('vue > errorHandler',error);
			this.dialog.display = true;
			var self = this;
			this.dialog.onClose = function() {
				self.dialog.display = false;
			};

			var message = error;
			if(error.error) {
				message = this.$Localization.objStr(error, 'error');
			}
			else if(error.message) {
				message = error.message;
			}

			if(message.search('timeout')==0){
				this.dialog.message = {
					header: this.str('timeout'),
					body: this.str('if_problem')
				}
			} else {
				this.dialog.message = {
					header: this.str('something_went_wrong'),
					body: message + '<br><br>' + this.str('if_problem'),
				}
			}
		},
		language: function(language){
			// lang was changed
			localStorage.setItem('language', language);
			this.$Localization.setLanguage(language);
			this.currentLang = language;
		},
		str: function(val) {
			return this.$Localization.str(val);
		},		
		logout: function() {
			// this.$router.push('/logout');
			console.log('logging out');
			this.$application.logout();
		},
		close_dialog: function(){
			this.dialog.display = false;
			this.dialog.message = null;
			if(this.dialog.onClose){
				this.dialog.onClose()
			}
		},
		close_and_recover: function(){
			location.reload();
		},
		busyState: function() {
			return this.$application.getBusyState();
		},
		cycleBrand: function(){
			var array = ['Toyota','Lexus','Toyota - Lexus'];
			this.override_index++;
			if(this.override_index>=array.length){
				this.override_index = 0;
			}
			this.brand_override = array[this.override_index];
		}
	},
	computed: {
		isLoggedIn: function() {
			return this.$application.isLoggedIn();
		},
		fullname: function() {
			return this.$application.getUserFullName();
		},
		userType: function() {
			return this.$application.getUserTypeString();
		},
		userLanguage: function() {
			return this.currentLang;
		},
		dealerCode: function() {
			return this.$application.getDealerCode();
		},
		username: function() {
			return this.$application.getUser().username;
		},
		brand: function(){
			// return this.brand_override;
			return this.$application.brand();
		},
		toyota: function(){
			return toyota;
		},
		lexus: function(){
			return lexus;
		},
		lexus_fr: function () {
        	return lexus_fr;
   		},
		allowAdmin: function(){
			return this.$application.allowAdmin();
		},
		zoneNames: function() {
			if(this.user && this.user.zones) {
				return this.user.zones.map(function(val) {
					return val.name
				}).join(', ');
			}
			else {
				return null;
			}
		},
		version: function() {
			return this.$application.getVersion();
		}
	},
	watch: {
		
	}
}
</script>


<style module>
.navmain {
	display: flex;
	flex-direction: row;
	padding: 5px 40px;
}
.navmain > * {
	flex-grow: 1;
}
.logowrapper {
	flex: 2;
	display: flex;
	padding-bottom: 5px;
	transform: translateY(-20%);
}
.logo {
	display: inline-block;
	vertical-align: middle;
	align-self: flex-end;
}
h1 {
	font-size: 1.2em;
	color: #666;
	font-weight: normal;
	display: inline-block;
	vertical-align: middle;
	margin: 0px 10px 5px;
	align-self: flex-end;
}

.one_brand{
	border-left: 1px solid grey;
	padding-left: 5px;
}
.appBar{
	font-size: 12pt;
	/* font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; */
}
.navbar {
	background: #eee;
	position: relative;
	padding: 5px 20px;
}
.navlinks {
	display: inline-block;
}
.optionswrapper {
	position: absolute;
	right: 40px;
	top: 4px;
}
.optionswrapper > * {
	display: inline-block;
	vertical-align: bottom;
}
.userDetails {
	text-align: right;
	color: #888;
	font-size: 0.9em;
	flex: 1;
}
.username { 
	font-size: 1.2em;
	font-weight: bold;
	color: #555;
}
.logout{
	font-size: 0.8em;
	text-align: center;
	padding: 3px 20px;
}
.version {
	display: none;
	font-size: 0.8em;
}
</style>


<style lang="scss">
@import "@/_variables.scss";
.toyota img.header_logo{
	height:45px;
	transform: translateY(15%)
}

.lexus img.header_logo{
	height:35px;
}

button {
	color: white;
	font-weight: 600;
	font-size: 10pt;
	padding: 2px 10px;
	border-radius: 6px;
	background-color: lightslategray;
	border: none;
}
button.big{
	color: white;
	font-weight: 600;
	font-size: 10pt;
	padding: 4px 15px;
	border-radius: 6px;
	background-color: lightslategray;
}


.lexus button{
	background-color: $lexus;
}

.toyota button.primary {
	background-color: $toyota;
}

body {
	margin: 0px;
	padding: 0px;
}
#app {
	/*font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;*/
	
	font-family: 'Roboto', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}
#nav {
	background-color: white;
}

a.navlink {
	font-weight: bold;
	color: #2c3e50;
	text-decoration: none;
	font-size: 0.9em;
	border-left: 1px solid #ccc;
	display: inline-block;
	padding: 2px 20px;
}
a.navlink:hover {
	background: #ccc;
}
a.navlink:last-child {
	border-right: 1px solid #ccc;
}

a.navlink.router-link-exact-active {
	color: rgb(237, 27, 47);
}

#nav button{
	min-width: 100px;
}

#main {
	// margin: 20px 40px;
	background-color: #fdfdfd;
	position: relative;
	text-align: center;
}
.options {
	position: absolute;
	top: 0px;
	right: 0px;
	padding: 20px 30px;
}
</style>


<style src="@/assets/css/material_fonts.css"></style>
<style src="@/assets/css/material_icons.css"></style>
<style src="@/assets/css/all.css"></style>
<style src="@/assets/css/animate.css"></style>